<template>
  <div class="orderBox">
    <div class="form-title">实际缴费信息</div>

    <template v-if="canEdit || $units.isSelfOrg(formData.policyInfo)">
      <FormItem label="付款人姓名：">
        <Select v-if="canEdit" v-model="formData.payerName" @on-change="changeName">
          <Option v-for="item in names" :value="item.name" :key="item.name">{{ item.name }}</Option>
        </Select>
        <span v-else class="descrypt-text" @dblclick="openEye(formData, 'payerName')">{{ formData.payerName }}</span>
        <a v-if="!canEdit && formData.payerName" style="position: absolute; color: #2d8cf0 !important">
          <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowpayerName" @click="openEye(formData, 'payerName')"></i>
        </a>
      </FormItem>
      <FormItem label="付款银行：">
        <lzDicSelect v-if="canEdit" v-model="formData.bank" dicType="BANK_TYPE" transfer clearable />
        <lzDicTxt v-else dicType="BANK_TYPE" :dicCode="formData.bank" defaultText="-" />
      </FormItem>
      <FormItem label="银行账号：">
        <Input v-if="canEdit" v-model="formData.bankCardNo" placeholder="请输入" />
        <span v-else class="descrypt-text" @dblclick="openEye(formData, 'bankCardNo')">{{ formData.bankCardNo || '-' }}</span>
        <a v-if="!canEdit && formData.bankCardNo" style="position: absolute; color: #2d8cf0 !important">
          <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowbankCardNo" @click="openEye(formData, 'bankCardNo')"></i>
        </a>
      </FormItem>
    </template>
    <!-- <FormItem v-if="!canEdit" label="当期实际已缴费：">{{ totalAmount }}</FormItem> -->
    <FormItem label="最新保费到期日：">{{ formData.policyInfo.expireDate | dateStrFilter }}</FormItem>
    <div class="paymentList">
      <Card v-for="(item, idx) in formData.policyPayments" :key="item.id" dis-hover>
        <Icon
          v-if="!item.id && canEdit && formData.policyPayments.length > 1"
          type="ios-trash-outline"
          class="delPolicyPaymentBtn"
          size="24"
          color="red"
          @click="delItem(idx)"
        />
        <FormItem label="付款方式：">
          <lzDicSelect v-if="!item.id && canEdit" v-model="item.paymentWay" dicType="FIRST_PAY_TYPE" transfer clearable />
          <lzDicTxt v-else dicType="FIRST_PAY_TYPE" :dicCode="item.paymentWay" defaultText="-" />
        </FormItem>
        <FormItem
          label="付款币种："
          :prop="`policyPayments[${idx}].currency`"
          :rules="!item.id && canEdit ? $units.formRule.required('请选择') : { required: false }"
        >
          <lzDicSelect v-if="!item.id && canEdit" v-model="item.currency" dicType="CURRENCY_TYPE" transfer clearable :disabled="!!item.id || !canEdit" />
          <lzDicTxt v-else dicType="CURRENCY_TYPE" :dicCode="item.currency" defaultText="-" />
        </FormItem>
        <FormItem
          label="缴费金额（E）："
          :prop="`policyPayments[${idx}].amount`"
          :rules="!item.id && canEdit ? $units.formRule.required('请输入') : { required: false }"
        >
          <Input v-if="!item.id && canEdit" v-model="item.amount" placeholder="请输入" />
          <span v-else>{{ item.amount || '-' }}</span>
        </FormItem>
        <FormItem
          label="缴费日期："
          :prop="`policyPayments[${idx}].paymentDate`"
          :rules="!item.id && canEdit ? $units.formRule.required('请选择') : { required: false }"
        >
          <DatePicker
            v-if="!item.id && canEdit"
            type="date"
            transfer
            :editable="false"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :value="item.paymentDate"
            @on-change="$set(item, 'paymentDate', $event)"
          />
          <span v-else>{{ item.paymentDate | dateStrFilter }}</span>
        </FormItem>
        <FormItem v-if="$units.isSelfOrg(formData.policyInfo)" label="缴费凭证：" :prop="`policyPayments[${idx}]._img1`">
          <uploadNew v-model="item._img1" @show="openEye(item, '_img1')" fileType="img" :muti="true" :disabled="!!item.id || !canEdit" />
          <div v-if="!item.id && canEdit">仅支持图片格式</div>
        </FormItem>
        <FormItem v-if="$units.isSelfOrg(formData.policyInfo)" label="账户证明：" :prop="`policyPayments[${idx}]._img2`">
          <uploadNew v-model="item._img2" @show="openEye(item, '_img2', 1)" fileType="img" :muti="true" :disabled="!!item.id || !canEdit" />
          <div v-if="!item.id && canEdit">仅支持图片格式</div>
        </FormItem>
        <FormItem v-if="item.id" label="对账状态：" :prop="`policyPayments[${idx}].status`" class="form-item-decrypt">
          <span class="descrypt-text">{{ item.status | renewalStateFilter }}</span>
        </FormItem>
        <FormItem v-if="formData.renewalState == 5" label="保司收到日期：">{{ item.receiveDate | dateStrFilter }}</FormItem>
        <FormItem v-if="formData.renewalState == 5" label="保司收到金额：">{{ item.receiveAmount }}</FormItem>
      </Card>
    </div>
    <Button v-if="canEdit" class="addPolicyPaymentBtn" type="success" icon="ios-add" ghost @click="addPayment()">新增缴费信息</Button>

    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import lzDicSelect from '@/components/commons/lzDicSelect';
import lzDicTxt from '@/components/commons/lzDicTxt';
import uploadNew from '@/components/commons/maskUploadNew';
import validUserName from '@/components/commons/validUserName';
import Decimal from 'decimal.js';
const dic = JSON.parse(localStorage.dic);
const policyStatusDic = dic['POLICY_STATUS']; // 保单状态
const CURRENCY_TYPE = dic['CURRENCY_TYPE']; // 货币类型
export default {
  mixins: [common],
  props: ['formData'],
  components: {
    lzDicSelect,
    lzDicTxt,
    uploadNew,
    validUserName
  },
  data() {
    return {
      policyStatusDic, // 保单状态
      totalAmount: 0
    };
  },
  computed: {
    canEdit() {
      return ['0', '1', '2', '3', '4'].includes(this.formData.renewalState)
    },
    names() {
      const name = this.formData.policyInfo.name;
      const insuranceName = this.formData.policyInfo.insuranceName;
      const arr = [{ name: name, type: '1' }];
      if (insuranceName && name != insuranceName) {
        arr.push({ name: insuranceName, type: '2' });
      }
      return arr;
    },
    amounts() {
      return ((this.formData || {}).policyPayments || []).map((item, idx) => {
        return {
          currency: item.currency,
          amount: item.amount || 0
        };
      });
    }
  },
  filters: {
    renewalStateFilter(val) {
      switch (val * 1) {
        case 1:
          return '已添加对账申请';
        case 2:
          return '已提交保司对账';
        case 3:
          return '保司已入账';
        case 6:
          return ' 续期成功';
        default:
          return '-';
      }
    },
    dateStrFilter(val = '') {
      if (!val) {
        return '-';
      }
      return val.substring(0, 10);
    },
    policyStatusFilter(val) {
      if (!val) {
        return '-';
      }
      return policyStatusDic[val];
    },
    currencyTypeFilter(val) {
      if (!val) {
        return '-';
      }
      return CURRENCY_TYPE[val] || '';
    }
  },
  watch: {
    formData: {
      handler(newFormData) {
        this.$nextTick(() => {
          if (!newFormData.policyPayments || !newFormData.policyPayments.length) {
            this.addPayment();
          }
        });
      },
      deep: true,
      immediate: true
    },
    amounts: {
      handler(newVal) {
        // let totalUsd = new Decimal(0);
        // let totalHkd = new Decimal(0);
        // let r = new Decimal(this.formData.policyInfo.usdToHkdExchangeRate);
        // let t = 1;
        // newVal.forEach(a => {
        //   switch (a.currency * 1) {
        //     case 1:
        //       // 港币
        //       totalUsd = totalUsd.add(new Decimal(a.amount).div(r));
        //       totalHkd = totalHkd.add(new Decimal(a.amount));
        //       break;
        //     case 2:
        //       // 美元
        //       totalUsd = totalUsd.add(new Decimal(a.amount));
        //       totalHkd = totalHkd.add(new Decimal(a.amount).mul(r));
        //       t = 2;
        //       break;
        //     case 3:
        //       // 人民币
        //       break;
        //     default:
        //       break;
        //   }
        // });
        // const totalAmount = (t == 1 ? totalHkd : totalUsd).toFixed(2, Decimal.ROUND_DOWN).toString();
        // const suffix = t == 1 ? ' 港币' : ' 美元';
        let suffix = '';
        let totalAmount = new Decimal(0);
        newVal.forEach(a => {
          const newSuffix = CURRENCY_TYPE[a.currency] || '';
          if (newSuffix) {
            suffix = newSuffix;
          }
          totalAmount = totalAmount.add(new Decimal(a.amount));
        });
        totalAmount = totalAmount.toFixed(2, Decimal.ROUND_DOWN).toString();
        this.$set(this.formData, 'paidPremium', totalAmount);
        this.totalAmount = totalAmount + suffix;
      },
      immediate: true
    }
  },
  methods: {
    changeName() {
      if (this.formData.payerName) {
        this.formData.customerType = this.names.find(item => item.name == this.formData.payerName).type;
      }
    },
    openEye(row, code) {
      if (!row['validName' + code]) {
        this.$refs.validUserNameRef.open(row, code);
        return;
      }
      if (!row['eyeShow' + code]) {
        let cardType = {
          '_img1': '缴费凭证',
          '_img2': '账户证明'
        };
        let operationType = {
          // 1-证件号解密  2-手机号解密 3-银行卡号 4-邮箱  5-通讯地址   6-身份证地址 7-居住地地址 8-通行证/护照号码 9-公司/学校名称 10-公司/学校地址
          idcardNo: 1,
          mobile: 2,
          bankCardNo: 3,
          idcardAddr: 6,
          currentAddr: 7,
          postalAddr: 5,
          passportCode: 8,
          company: 9,
          address: 10,
          policyNo: 11,
          payerName: 12,
          insuranceName: 12
        };
        let customerType = {
          payerName: 1,
          bankCardNo: 1,
          insuranceName: 2
        };
        this.descrypt(
          {
            id: row.id,
            cardType: cardType[code],
            customerType: customerType[code], //投保人
            query: this.formData.id,
            operationType: operationType[code] || 14,
            operationFunction: 7
          },
          row,
          code
        ).then(() => {
          this.$set(row, 'eyeShow' + code, true);
        });
      }
    },
    getPicSrc(item, t) {
      const picList = item.attachments || [];
      if (!picList.length) return '';
      const pic = picList.find(item => item.type == t) || {};
      return pic.path || '';
    },
    addPayment() {
      if (!this.formData.policyPayments) {
        this.$set(this.formData, 'policyPayments', []);
      }
      this.$nextTick(() => {
        this.formData.policyPayments.push({
          paymentWay: (this.formData.policyInfo || {}).firstPaymentMethod || '',
          currency: (this.formData.policyInfo || {}).currencyType || '',
          amount: '',
          paymentDate: '',
          attachments: [],
          receiveDate: '',
          receiveAmount: '',
          status: '1'
        });
      });
    },
    delItem(idx) {
      this.formData.policyPayments.splice(idx, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.paymentList /deep/ .ivu-card {
  margin-bottom: 20px;
  padding-top: 20px;
  padding-right: 50px;
}

.addPolicyPaymentBtn {
  width: 300px;
  height: 40px;
  font-size: 1.1em;
}

.delPolicyPaymentBtn {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}

.pic {
  width: 120px;
  height: 120px;
}
</style>
